function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { get, stubTrue, every, wrapDisplayName } from './utils';
/**
 * A function that returns a React HOC to handle renderWhen logic for loading state.
 *
 * For the renderWhen param, the type can be one of the following:
 * * String - The name of a prop to wait for. When the prop is truthy, the component will render.
 * * Function - A function that recieves the component props and returns a boolean. When it returns true, the component will render.
 * * Array - An array of prop names to wait for. Each prop name will be evaluated using the `String` rules.
 * * Object - An object where the keys are prop names and the values are expected values. When the prop values are equal to the expected values, the component will render.
 *
 * @name waitFor
 * @param {(String|Function|Object)} renderWhen - A rule indicating when the wrapped component may render.
 * @param {Function} [LoadingComponent] - A component to render during the loading state, will be passed the current props. If not provided, `<div id="spinner" />` will be rendered. To hide this component, pass in `false` or `null`.
 * @returns {Function} - Returns a higher order component (HOC) to handle conditional logic for loading states.
 * @example
 *
 *  function MyComponent (name) {
 *    return (
 *      <p>{name}</p>
 *    )
 *  }
 *
 *  const renderWhen = 'name'
 *
 *  waitFor(renderWhen, MyComponent)
 *  // When prop 'name' value evaluates to true, MyComponent will be rendered.
 *  // Otherwise, the <Spinner /> component from `lp-components` will be rendered.
*/

function DefaultLoadingComponent() {
  return React.createElement("div", {
    id: "spinner"
  });
}

export default function waitFor(renderWhen) {
  var LoadingComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultLoadingComponent;
  var doRender = getRenderCondition(renderWhen);
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(waitFor, _React$Component);

      function waitFor() {
        _classCallCheck(this, waitFor);

        return _possibleConstructorReturn(this, _getPrototypeOf(waitFor).apply(this, arguments));
      }

      _createClass(waitFor, [{
        key: "render",

        /*
         * A friendly name for React devtools and errors
         */

        /*
         * A reference to the wrapped component
         */
        value: function render() {
          if (doRender(this.props)) return React.createElement(WrappedComponent, this.props);
          if (!LoadingComponent) return null;
          return React.createElement(LoadingComponent, this.props);
        }
      }]);

      return waitFor;
    }(React.Component), _defineProperty(_class, "displayName", wrapDisplayName(WrappedComponent, 'waitFor')), _defineProperty(_class, "WrappedComponent", WrappedComponent), _temp;
  };
}

function getRenderCondition(renderWhen) {
  var type = _typeof(renderWhen);

  if (Array.isArray(renderWhen)) type = 'array';

  switch (type) {
    case 'function':
      return renderWhen;

    case 'string':
      return function (props) {
        return isTruthy(renderWhen, props);
      };

    case 'array':
      return function (props) {
        return renderWhen.every(function (propName) {
          return isTruthy(propName, props);
        });
      };

    case 'object':
      return function (props) {
        return every(renderWhen, function (value, key) {
          var propValue = get(key, props);
          return propValue === value;
        });
      };

    default:
      return stubTrue;
  }
} // Returns true if prop is truthy


function isTruthy(propName, props) {
  return !!get(propName, props);
}